import BuscaAbogado from './BuscaAbogado';

export default BuscaAbogado;
